function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m145.1 366.9c-10.805-10.805-20.406-22.488-28.754-34.883l-33.066 33.062 63.641 63.641 33.062-33.066c-12.395-8.3477-24.078-17.949-34.883-28.754z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m62.066 386.3-48.887 48.883c-8.5 8.5-13.18 19.801-13.18 31.82s4.6797 23.32 13.18 31.82 19.801 13.18 31.82 13.18 23.32-4.6836 31.82-13.18l48.883-48.887z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m309.5 0c-111.84 0-202.5 90.664-202.5 202.5s90.664 202.5 202.5 202.5 202.5-90.66 202.5-202.5-90.66-202.5-202.5-202.5zm0 360c-86.844 0-157.5-70.652-157.5-157.5s70.656-157.5 157.5-157.5 157.5 70.656 157.5 157.5-70.652 157.5-157.5 157.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m309.5 75c-70.305 0-127.5 57.195-127.5 127.5s57.195 127.5 127.5 127.5 127.5-57.195 127.5-127.5-57.195-127.5-127.5-127.5zm15 219.71h-30v-30h30zm21.164-101.77-21.164 23.672v18.094h-30v-29.551l28.805-32.215c3.0469-3.4062 4.7227-7.793 4.7227-12.352 0-10.219-8.3086-18.531-18.527-18.531s-18.527 8.3125-18.527 18.531h-30c0-26.762 21.77-48.531 48.527-48.531s48.527 21.77 48.527 48.531c0.003906 11.953-4.3867 23.441-12.363 32.352z"
});

var SvgEnquiry = function SvgEnquiry(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    fill: "#FFF",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnquiry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enquiry.0322a755.svg";
export { ForwardRef as ReactComponent };